import { render } from "./OutputView.vue?vue&type=template&id=5b726e05&lang=html"
import script from "./OutputView.vue?vue&type=script&lang=js"
export * from "./OutputView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/peterdevos/Sites/aethonspel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__